'use client';

import { useState } from 'react';
import { BookOpen, Menu, X, User } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ALL_AUTHORS } from '@/constants/authors';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const router = useRouter();

  const navLinks = ALL_AUTHORS.map((author) => ({
    name: author.displayName,
    href: `/${author.slug}`,
  }));

  return (
    <header className="sticky top-0 z-50 bg-background/70 backdrop-blur-2xl border-b border-border/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-18">
          <Link href="/" className="flex items-center gap-3 group">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-primary to-secondary rounded-full blur-md opacity-30 group-hover:opacity-60 transition-opacity" />
              <div className="relative bg-gradient-to-br from-primary to-primary-hover p-2.5 rounded-xl shadow-lg">
                <BookOpen className="w-6 h-6 sm:w-7 sm:h-7 text-white" strokeWidth={2.5} />
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
                Minifictionverse
              </span>
              <span className="text-[10px] sm:text-xs text-muted -mt-1 hidden sm:block">
                Welcome to fantasy world
              </span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                href={link.href}
                className="relative group px-4 py-2 text-sm font-medium
                  text-foreground/80 hover:text-foreground transition-colors"
              >
                <span className="relative z-10">{link.name}</span>
                <div className="absolute inset-0 bg-accent rounded-lg
                  opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2
                  w-0 h-0.5 bg-gradient-to-r from-primary to-secondary
                  group-hover:w-3/4 transition-all duration-300" />
              </Link>
            ))}
          </nav>

        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden border-t border-border/40
          bg-background/90 backdrop-blur-2xl">
          <nav className="px-4 py-6 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className="relative group flex items-center gap-3 px-4 py-3
                  text-base font-medium text-foreground/80
                  hover:text-foreground rounded-xl transition-all duration-200"
              >
                <div className="w-1 h-8 bg-gradient-to-b from-primary
                  to-secondary rounded-full opacity-0 group-hover:opacity-100
                  transition-opacity absolute left-0" />
                <span className="relative">{link.name}</span>
                <div className="absolute inset-0 bg-accent/50 rounded-xl
                  opacity-0 group-hover:opacity-100 transition-opacity -z-10" />
              </Link>
            ))}
            
          </nav>
        </div>
      )}
    </header>
  );
}
